import { render, staticRenderFns } from "./WorklistCard.vue?vue&type=template&id=c5f46144"
import script from "./WorklistCard.vue?vue&type=script&lang=js"
export * from "./WorklistCard.vue?vue&type=script&lang=js"
import style0 from "./WorklistCard.vue?vue&type=style&index=0&id=c5f46144&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports